import { render, staticRenderFns } from "./OcpcMain.vue?vue&type=template&id=0c414e32&scoped=true"
import script from "./OcpcMain.vue?vue&type=script&lang=js"
export * from "./OcpcMain.vue?vue&type=script&lang=js"
import style0 from "./OcpcMain.vue?vue&type=style&index=0&id=0c414e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c414e32",
  null
  
)

export default component.exports